import BlogLayout from '../components/BlogLayout/BlogLayout';
import SEO from '../components/SEO/SEO';
import Titles from '../components/Titles/Titles';
import Make from '../components/MakeSection/Make';
import BlogContent from '../components/BlogLayout/BlogContent';
import { usePageSEO } from '../hooks/usePageSEO';

const Blog = ({ hideHeaderFooter, hideLanguageSwitcher }) => {
  const seo = usePageSEO('blog');
  
  return (
    <BlogLayout hideHeaderFooter={hideHeaderFooter} hideLanguageSwitcher={hideLanguageSwitcher}>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <Titles page="BlogPage" />
      <BlogContent />
      <Make pageKey="blogPage" />
    </BlogLayout>
  );
};

export default Blog;